import * as React from 'react';
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
} from 'react-simple-maps';

const wrapperStyles = {
  width: '100%',
  maxWidth: 980,
  margin: '0 auto',
};

const colour = (data: any, highlighted: string[]) => {
  if (highlighted.includes(data.properties.name)) {
    return '#F9C876';
  }

  return '#DADADA';
};

export interface Props {
  highlighted: string[];
}

export const MapPanel = (props: Props) => (
  <div style={wrapperStyles}>
    <ComposableMap
      projectionConfig={{
        scale: 205,
        rotation: [-11, 0, 0],
      }}
      width={980}
      height={551}
      style={{
        width: '100%',
        height: 'auto',
      }}
    >
      <ZoomableGroup center={[0, 20]} disablePanning>
        <Geographies geography="/world-50m.json">
          {(geographies: any, projection: any) =>
            geographies.map(
              (geography: any, i: any) =>
                geography.id !== 'ATA' && (
                  <Geography
                    key={i}
                    geography={geography}
                    projection={projection}
                    style={{
                      default: {
                        fill: colour(geography, props.highlighted || ['GB']),
                        stroke: '#F9F9F9',
                        strokeWidth: 0.75,
                        outline: 'none',
                      },
                      hover: {
                        fill: '#D3D3D3',
                        stroke: '#F9F9F9',
                        strokeWidth: 0.75,
                        outline: 'none',
                      },
                      pressed: {
                        fill: '#F5A623',
                        stroke: '#F5A623',
                        strokeWidth: 0.75,
                        outline: 'none',
                      },
                    }}
                  />
                ),
            )
          }
        </Geographies>
      </ZoomableGroup>
    </ComposableMap>
  </div>
);

export default MapPanel;
